export type ListingSurfaceKey =
  | 'property_hub'
  | 'classifieds_hub'
  | 'business_directory'
  | 'vendor_properties_hub'
  | 'vendor_subscription'
  | 'vendor_onboard_property';

export interface ListingSurfaceConfig {
  surfaceKey: ListingSurfaceKey;
  title: string;
  subtitle?: string;
  bodyMarkdown?: string;
  primaryCtaLabel?: string;
  primaryCtaPath?: string;
  secondaryCtaLabel?: string;
  secondaryCtaPath?: string;
  heroImageUrl?: string;
  metadata?: Record<string, unknown>;
}

export const LISTING_SURFACE_KEYS: ListingSurfaceKey[] = [
  'property_hub',
  'classifieds_hub',
  'business_directory',
  'vendor_properties_hub',
  'vendor_subscription',
  'vendor_onboard_property',
];

export const LISTING_SURFACE_LABELS: Record<ListingSurfaceKey, string> = {
  property_hub: 'Property hub (public)',
  classifieds_hub: 'Classifieds hub',
  business_directory: 'Business directory',
  vendor_properties_hub: 'Vendor properties hub',
  vendor_subscription: 'Vendor subscription page',
  vendor_onboard_property: 'Vendor onboard (property sector)',
};

export const DEFAULT_LISTING_SURFACES: ListingSurfaceConfig[] = [
  {
    surfaceKey: 'property_hub',
    title: 'Properties in Grenada',
    subtitle: 'Homes, land, and commercial space for sale or rent.',
    primaryCtaLabel: 'List your property',
    primaryCtaPath: '/grenada/classifieds/post?category=property',
    secondaryCtaLabel: 'Join as agency',
    secondaryCtaPath: '/sell?sector=property',
  },
  {
    surfaceKey: 'classifieds_hub',
    title: 'Grenadian classifieds',
    subtitle: 'Buy and sell across Grenada — cars, jobs, electronics, services, and more.',
    primaryCtaLabel: 'Post an ad',
    primaryCtaPath: '/grenada/classifieds/post',
  },
  {
    surfaceKey: 'business_directory',
    title: 'Local businesses',
    subtitle: 'Discover Grenadian sellers — shop products, book appointments, or hire a pro.',
    primaryCtaLabel: 'List your business',
    primaryCtaPath: '/sell',
    secondaryCtaLabel: 'Shop products',
    secondaryCtaPath: '/grenada/shop',
  },
  {
    surfaceKey: 'vendor_properties_hub',
    title: 'Property listings',
    subtitle: 'Manage homes and land for sale or rent from your agency dashboard.',
    primaryCtaLabel: 'Add listing',
    primaryCtaPath: '/hub/properties/new',
  },
  {
    surfaceKey: 'vendor_subscription',
    title: 'Choose the right plan',
    subtitle: 'Upgrade for more listings, card payments, analytics, and property quotas.',
  },
  {
    surfaceKey: 'vendor_onboard_property',
    title: 'List property on ShopGND',
    subtitle: 'Real estate agencies get a branded storefront, viewing requests, and plan-based listing quotas.',
    primaryCtaLabel: 'Continue setup',
    primaryCtaPath: '/sell',
  },
];
